import React, { useEffect, useState } from "react";
import { Calendar } from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import { format } from 'date-fns';
import './App.css';
import GroupData from './GroupData';
import logosmall from './images/logo-small.png';
import tempLogo from './images/logo-small.png';
import eventData from './EventData';


export default function HomePage() {
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [events, setEvents] = useState([]);
    const groups = GroupData;
    //const calendarData = require('./events.json');
    const calendarData = eventData;

    useEffect(() => {
        const sortedEvents = [...calendarData].sort(
            (a, b) => new Date(a.date) - new Date(b.date)
        );
        setEvents(sortedEvents);
    }, [calendarData]);

    const months = [0, 1];

    const renderCalendar = (monthOffset) => {
        const now = new Date();
        const date = new Date(now.getFullYear(), now.getMonth() + monthOffset, 1);

        return (
            <div key={monthOffset} className="calendar-wrapper">
                <Calendar
                    value={date}
                    tileContent={({ date }) => {
                        const dayEvents = events.filter(
                            (e) => format(new Date(e.date), 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd')
                        );
                        return dayEvents.map((event, idx) => (
                            <div
                                key={idx}
                                className="calendar-tile"
                                onClick={() => setSelectedEvent(event)}
                            >
                                {event.title}
                            </div>
                        ));
                    }}
                    tileClassName={({ date, view }) => {
                        if (view === 'month') {
                            if (date.getDate() === 1) {
                                return 'first-day-of-month';
                            }
                            
                        }
                        return null;
                    }}
                    showNeighboringMonth={false}
                />
            </div>
        );
    };

    return (
        <div className="app-container">
            <div className="top-bar">
                <img src={logosmall} alt="Logo" className="logo-small" />
                <span className="site-title">Bladers.ca</span>
            </div>

            <div className="groups-center-wrapper">
                <div className="groups-scroll-container">
                    <div className="groups-section">
                        {groups.map((group, index) => (
                            <div key={index} className="group-card">
                                <a href={`/group/${index}`}>
                                    <img src={group.image} alt={group.name} className="group-image" />
                                </a>
                                <div className="group-name">
                                    <a href={`/group/${index}`}>{group.name}</a>
                                </div>


                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="calendar-section">
                {months.map((offset) => renderCalendar(offset))}
            </div>

            {selectedEvent && (
                <div className="event-modal">
                    <h3>{selectedEvent.title}</h3>
                    <p>{format(new Date(selectedEvent.date), 'PPP')}</p>
                    <p>{selectedEvent.description}</p>
                    <button onClick={() => setSelectedEvent(null)}>Close</button>
                </div>
            )}

            <div className="events-list">
                <h2>Contests and Events</h2>
                {events.map((event, idx) => (
                    <div className="event-entry">
                        <div className="event-left">
                            <img src={tempLogo} alt="Event Logo" className="event-logo" />
                            <div className="event-type">{event.type}</div>
                        </div>
                        <div className="event-right">
                            <div className="event-date">{event.date}</div>
                            <div className="event-title">{event.title}</div>
                            <div className="event-description">{event.description}</div>
                            {event.link && (
                                <a href={event.link} target="_blank" rel="noopener noreferrer" className="event-link">
                                    {event.link}
                                </a>
                            )}
                            <div className="event-more">
                                <a href={`/event/${idx}`}>View More</a>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

/*
<div className="event-entry">
                        <div className="event-left">
                            <img src={event.logo} alt="Event Logo" className="event-logo" />
                            <div className="event-type">{event.type}</div>
                        </div>
                        <div className="event-right">
                            <div className="event-date">{event.date}</div>
                            <div className="event-title">{event.title}</div>
                            <div className="event-description">{event.description}</div>
                        </div>
                    </div>
*/
